
import React from 'react';
import { Typography } from 'antd';
import './styles.css';

const { Text } = Typography;

export const Loading = ({ loadingMessage }) => (
  <div className="loading--main-container">
    <div className="loading--loading-container">
      <h1 className="loading--title default">MULTICOTIZADOR</h1>
      {loadingMessage && <Text type='secondary' style={{ display: 'block' }}>{loadingMessage}...</Text>}
      <div className="loading--loading-animation"><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
);